var _ = require('underscore');

module.exports = {
  convertToGMapsCoordinates: function (coordinates) {
    return _.map(coordinates, function (coordinate) {
      return {
        lat: coordinate[0],
        lng: coordinate[1]
      };
    });
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/geometry-views/gmaps/gmaps-coordinates.js
// module id = 782
// module chunks = 6